export default __webpack_public_path__ + "static/media/WritingGameNoTicking.db45ffee.wav";